import { Grid, Paper, Box, Typography } from "@mui/material";
import Loader from "Components/Loader";
import ImgPath from "Constants/Imgs";
import { RouteUrls } from "Constants/RouteUrls";
import { DashboardCardType } from "DataTypes/Dashboard.type";
import { UserInitialStateType } from "DataTypes/Redux";
import { Component, JSX, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CaseApi from "Service/Case.api";
import ContactUsDialog from "./ContactUsDialog";

const DashboardCards = () => {
  const navigate = useNavigate();
  const [cards, setCards] = useState<DashboardCardType[]>([]);
  const [loading, setLoading] = useState(false);
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );

  const cardData = [
    {
      title: "Earn & Payments",
      count: 0,
      icon: ImgPath.EarnAndPayIcon,
      path: "#",
    },
    {
      title: "Applicaion & Calender",
      count: 0,
      icon: ImgPath.ApplicationCalIcon,
      path: "#",
    },
    {
      title: "Contact Us",
      count: 0,
      icon: ImgPath.ContactUsIcon,
      path: "contact",
    },
    ...(myInfo.userType === "ADMIN"
      ? [
          {
            title: "Corporate Users",
            count: 0,
            icon: ImgPath.KnowledgeBankIcon,
            path: `/${RouteUrls.corporateList}`,
          },
        ]
      : []),
    ...(myInfo.userType === "ADMIN"
      ? [
          {
            title: "Professional Users",
            count: 0,
            icon: ImgPath.KnowledgeBankIcon,
            path: `/${RouteUrls.professionalUsers}`,
          },
        ]
      : []),
    ...(myInfo.userType === "ADMIN"
      ? [
          {
            title: "Assign professional to case",
            count: 0,
            icon: ImgPath.KnowledgeBankIcon,
            path: `/${RouteUrls.AssignProfessional}`,
          },
        ]
      : []),
  ];
  useEffect(() => {
    handleOnLoad();
  }, []);

  const handleOnLoad: () => void = async () => {
    setLoading(true);
    const res = await CaseApi.getDashboardCount();
    if (res?.success) {
      const newArr: DashboardCardType[] = res?.data
        ?.map((el: any) => {
          return {
            title: `${el?.orderTypeName} Orders`,
            count: el?.caseCount,
            icon: getCardIconByOrderTypeId(el?.orderTypeId),
            path: getCardPath(el),
          };
        })
        ?.filter((el: DashboardCardType) => el.count > 0);
      setCards([...newArr, ...cardData]);
    }
    setLoading(false);
  };

  const getCardPath: (el: any) => string = (el) => {
    console.log("elment", el);
    if (el?.orderTypeName === "Active") {
      return `/${RouteUrls.chat}`;
    } else {
      return `/${RouteUrls.chat}/${el?.orderTypeId}`;
    }
  };

const getCardIconByOrderTypeId = (orderTypeId: number): string => {
  try {
    return require(`../../Assets/Imgs/DashboardIcons/${"Icon"+orderTypeId}.png`);
  } catch {
    return require(`../../Assets/Imgs/DashboardIcons/defaultIcon.png`); // fallback image
  }
};

  return (
    <Box overflow={"auto"} height={"100%"} >
    <Grid container spacing={3} px={2}>
      {loading ? (
        <Loader />
      ) : (
        cards.map(({ title, count, icon, path }) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={title}>
            <Paper
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                borderRadius: 2,
                height: "100%",
                boxShadow: 3,
                cursor: "pointer",
              }}
            >
              <Box
                component="img"
                src={icon}
                alt={title}
                sx={{
                  width: { xs: 50, sm: 60, md: 70 }, // responsive: 50px (xs), 60px (sm), 70px (md+)
                  height: { xs: 50, sm: 60, md: 70 },
                  flexShrink: 0,
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  flex: 1,
                }}
                onClick={() => {
                  if (path === "contact") {
                    setContactDialogOpen(true);
                  } else if (path && path !== "#") {
                    navigate(path);
                  }
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 500,
                    fontSize: "1rem",
                    mb: 0.5, // margin-bottom
                    textAlign: "center",
                    overflowWrap: "break-word", // ensures consistent wrapping across browsers
                    whiteSpace: "normal", // allows line wrapping
                  }}
                >
                  {title}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    mb: 0.5, // margin-bottom
                    textAlign: "center",
                  }}
                >
                  {count}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))
      )}

      <ContactUsDialog
        open={contactDialogOpen}
        onClose={() => setContactDialogOpen(false)}
      />
    </Grid>
    </Box>
  );
};

export default DashboardCards;
